import { GridSize } from './models';
import { html, Position } from './utils';

type Listener = HTMLInputElement;

export function value(ls: Listener): string {
  let letter: string = ls.value;
  ls.value = '';
  return letter.toUpperCase();
}

export function update(l: Listener, [row, col]: Position, {rows, cols}: GridSize): void {
  l.style.top = ((row / rows) * 100).toString() + '%';
  l.style.left = ((col / cols) * 100).toString() + '%';
  if (document.activeElement !== l) {
    l.focus();
  }
}

export function create(element: HTMLElement): Listener {
  let listener: Listener = Elements.listener();
  element.appendChild(listener);
  return listener;
}

module Elements {
  export function listener(): Listener {
    let el: Listener = <Listener>html('input', ['wc-input-listener']);
    el.type = 'text';
    el.autocomplete = 'off';
    el.spellcheck = false;
    return el;
  }
}
